import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["operation", "trackingsection", "trackingtarget", "data"],
  _excluded2 = ["operation", "trackingsection", "trackingtarget", "data"],
  _excluded3 = ["operation", "trackingsection", "trackingtarget", "data"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useRef, useState } from 'react';
import MD5 from 'md5';
import { Dimensions, ScrollView, Platform } from 'react-native';
import { TRACKING_OPERATION } from '../../utils/tracking/constants';
import { dataMaintainer } from '../../components/ConfigProvider/rn/context';
import EventEmitter from 'events';
import { throttle } from '../../utils/tools';
import { useTracking as useWebTracking, useComponentTracking as useWebComponentTracking } from './useWebTracking';
var isWeb = Platform.OS === 'web';
export var useTracking = isWeb ? useWebTracking : useRNTracking;
export var useComponentTracking = isWeb ? useWebComponentTracking : useRNComponentTracking;
var targets = [];
export var TrackerScope;
(function (TrackerScope) {
  TrackerScope["OrderList"] = "OrderList";
  TrackerScope["TransactionList"] = "TransactionList";
})(TrackerScope || (TrackerScope = {}));
function useRNTracking(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    trackingImpressionProps = _useState2[0],
    setTrackingImpressionProps = _useState2[1];
  var trackingData = props.trackingData,
    componentData = props.componentData,
    scope = props.scope;
  var _getTrackingData = getTrackingData(trackingData, componentData),
    trackingClick = _getTrackingData.trackingClick,
    trackingImpression = _getTrackingData.trackingImpression;
  var trackRef = useRef(null);
  useEffect(function () {
    if (!trackingImpression) {
      return;
    }
    var trackingdata = trackingImpression.trackingdata,
      trackingsection = trackingImpression.trackingsection,
      trackingtarget = trackingImpression.trackingtarget;
    var trackingKey = MD5(trackingdata + trackingsection + trackingtarget);
    targets.push({
      scope: scope,
      key: trackingKey,
      ref: trackRef,
      visible: false,
      data: {
        trackingsection: trackingsection,
        trackingtarget: trackingtarget,
        trackingdata: trackingdata
      }
    });
    setTrackingImpressionProps({
      ref: trackRef
    });
    return function () {
      var index = targets.findIndex(function (t) {
        return t.key === trackingKey;
      });
      targets.splice(index, 1);
    };
  }, []);
  var click = function click(_ref) {
    var _dataMaintainer$track;
    var _ref$operation = _ref.operation,
      operation = _ref$operation === void 0 ? TRACKING_OPERATION.CLICK : _ref$operation,
      trackingsection = _ref.trackingsection,
      trackingtarget = _ref.trackingtarget,
      data = _ref.data,
      rest = _objectWithoutProperties(_ref, _excluded);
    (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : _dataMaintainer$track.dispatchTrack(_objectSpread({
      operation: operation,
      section: trackingsection,
      target: trackingtarget,
      data: data
    }, rest));
  };
  return {
    tracker: {
      click: click
    },
    trackingClick: trackingClick,
    trackingImpression: trackingImpression,
    trackingImpressionProps: trackingImpressionProps
  };
}
function useRNComponentTracking(props) {
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    result = _useState4[0],
    setResult = _useState4[1];
  var componentTrackingData = props.componentTrackingData,
    componentData = props.componentData,
    scope = props.scope;
  useEffect(function () {
    var trackingkeys = [];
    componentTrackingData && Object.keys(componentTrackingData).forEach(function (key) {
      var _getTrackingData2 = getTrackingData(componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData[key], componentData),
        trackingClick = _getTrackingData2.trackingClick,
        trackingImpression = _getTrackingData2.trackingImpression,
        trackingScroll = _getTrackingData2.trackingScroll;
      if (!trackingImpression) {
        return;
      }
      var _ref2 = trackingImpression,
        trackingdata = _ref2.trackingdata,
        trackingsection = _ref2.trackingsection,
        trackingtarget = _ref2.trackingtarget;
      var trackingKey = MD5(trackingdata + trackingsection + trackingtarget);
      trackingkeys.push(trackingKey);
      targets.push({
        scope: scope,
        key: trackingKey,
        ref: undefined,
        visible: false,
        data: {
          trackingsection: trackingsection,
          trackingtarget: trackingtarget,
          trackingdata: trackingdata
        }
      });
      setResult(function (old) {
        return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, key, {
          trackingClick: trackingClick,
          trackingScroll: trackingScroll,
          trackingImpression: trackingImpression,
          trackingImpressionProps: {
            ref: function ref(_ref3) {
              var target = targets.find(function (t) {
                return t.key === trackingKey;
              });
              if (target) {
                target.ref = _ref3;
              }
            }
          }
        }));
      });
    });
    return function () {
      trackingkeys.forEach(function (key) {
        var index = targets.findIndex(function (t) {
          return t.key === key;
        });
        targets.splice(index, 1);
      });
    };
  }, []);
  var click = function click(_ref4) {
    var _dataMaintainer$track2;
    var _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? TRACKING_OPERATION.CLICK : _ref4$operation,
      trackingsection = _ref4.trackingsection,
      trackingtarget = _ref4.trackingtarget,
      data = _ref4.data,
      rest = _objectWithoutProperties(_ref4, _excluded2);
    (_dataMaintainer$track2 = dataMaintainer.tracker) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.dispatchTrack(_objectSpread({
      operation: operation,
      section: trackingsection,
      target: trackingtarget,
      data: data
    }, rest));
  };
  var scroll = function scroll(_ref5) {
    var _dataMaintainer$track3;
    var _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? TRACKING_OPERATION.Scroll : _ref5$operation,
      trackingsection = _ref5.trackingsection,
      trackingtarget = _ref5.trackingtarget,
      data = _ref5.data,
      rest = _objectWithoutProperties(_ref5, _excluded3);
    (_dataMaintainer$track3 = dataMaintainer.tracker) === null || _dataMaintainer$track3 === void 0 ? void 0 : _dataMaintainer$track3.dispatchTrack(_objectSpread({
      operation: operation,
      section: trackingsection,
      target: trackingtarget,
      data: data
    }, rest));
  };
  return {
    tracker: {
      click: click,
      scroll: scroll
    },
    result: result
  };
}
var getTrackingData = function getTrackingData(trackingdata) {
  var componentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!trackingdata) {
    return {};
  }
  var _ref6 = trackingdata || {},
    bypassClickTracking = _ref6.bypassClickTracking,
    trackingsection = _ref6.trackingsection,
    trackingtarget = _ref6.trackingtarget,
    trackingdataBasic = _ref6.trackingdataBasic,
    trackingdataTarget = _ref6.trackingdataTarget,
    _ref6$trackingItemDat = _ref6.trackingItemData,
    trackingItemData = _ref6$trackingItemDat === void 0 ? function () {
      return {};
    } : _ref6$trackingItemDat;
  var impressionTrackingData = _objectSpread(_objectSpread({}, trackingdataBasic), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData));
  if (trackingdataTarget) {
    impressionTrackingData.button_details = [trackingdataTarget];
  }
  return {
    trackingClick: !bypassClickTracking ? {
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      data: _objectSpread(_objectSpread(_objectSpread({}, trackingdataBasic), trackingdataTarget), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData))
    } : undefined,
    trackingImpression: {
      // 'data-trackingindex': trackingindex,
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      trackingdata: JSON.stringify(impressionTrackingData)
    },
    trackingScroll: {
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      data: _objectSpread(_objectSpread({}, trackingdataBasic), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData))
    }
  };
};
var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
var handleIO = function handleIO(target) {
  try {
    var _ref7, _target$ref$current, _target$ref;
    (_ref7 = (_target$ref$current = (_target$ref = target.ref) === null || _target$ref === void 0 ? void 0 : _target$ref.current) !== null && _target$ref$current !== void 0 ? _target$ref$current : target.ref) === null || _ref7 === void 0 ? void 0 : _ref7.measureInWindow(function (x, y) {
      // console.log('======measureInWindow======', target, x, y);
      if (x < 0 || x > windowWidth || y < 0 || y > windowHeight) {
        target.visible = false;
      } else {
        if (!target.visible) {
          target.visible = true;
          var _target$data = target.data,
            trackingsection = _target$data.trackingsection,
            trackingtarget = _target$data.trackingtarget,
            trackingdata = _target$data.trackingdata;
          setTimeout(function () {
            reportImpression({
              trackingsection: trackingsection,
              trackingtarget: trackingtarget,
              trackingdata: trackingdata
            }); // if (trackingOnce) {
            //   const index = targets.findIndex((t) => t.key === target.key);
            //   targets.splice(index, 1);
            // }
          }, 1001); // 超过1s上报
        }
      }
    });
  } catch (err) {// do nothing
  }
};
var reportImpression = function reportImpression(_ref8) {
  var _dataMaintainer$track4;
  var _ref8$trackingsection = _ref8.trackingsection,
    trackingsection = _ref8$trackingsection === void 0 ? '' : _ref8$trackingsection,
    _ref8$trackingtarget = _ref8.trackingtarget,
    trackingtarget = _ref8$trackingtarget === void 0 ? '' : _ref8$trackingtarget,
    _ref8$trackingdata = _ref8.trackingdata,
    trackingdata = _ref8$trackingdata === void 0 ? '' : _ref8$trackingdata;
  var trackingdataObj;
  if (trackingdata) {
    try {
      if (typeof trackingdata === 'string') {
        trackingdataObj = JSON.parse(trackingdata);
      }
    } catch (error) {
      trackingdataObj = {};
    }
  } else {
    trackingdataObj = {};
  }
  (_dataMaintainer$track4 = dataMaintainer.tracker) === null || _dataMaintainer$track4 === void 0 ? void 0 : _dataMaintainer$track4.dispatchTrack({
    operation: TRACKING_OPERATION.IMPRESSION,
    section: trackingsection,
    target: trackingtarget,
    data: {
      viewed_objects: [
      // impression 统一补充
      _objectSpread({}, trackingdataObj)]
    }
  });
};
var trackerEvent = new EventEmitter();
var TRACKING_EVENT = 'TRACKING_EVENT';
export function emitTrackingEvent(scope) {
  trackerEvent.emit(TRACKING_EVENT, scope);
}
export function globalTrackerEventListener(scope) {
  // eslint-disable-next-line no-undef
  // if (__DEV__) {
  //   console.log('**********[Chatbot UI Tracker Report from web chatbot]*********** scope = ', scope);
  // }
  if (scope) {
    targets.filter(function (t) {
      return t.scope === scope;
    }).forEach(handleIO);
  } else {
    targets.forEach(handleIO);
  }
}
trackerEvent.on(TRACKING_EVENT, function (scope) {
  throttle(function () {
    // // eslint-disable-next-line no-undef
    // if (__DEV__) {
    //   console.log('**********[Chatbot UI Tracker Report]*********** scope = ', scope);
    // }
    targets.filter(function (t) {
      return t.scope === scope;
    }).forEach(handleIO);
  }, 500, true)();
});
export var ScrollType;
(function (ScrollType) {
  ScrollType["Vertical"] = "Vertical";
  ScrollType["Horizontal"] = "horizontal";
})(ScrollType || (ScrollType = {}));
export var TrackerScrollView = function TrackerScrollView(props) {
  var scope = props.scope,
    _props$scrollTrackOpt = props.scrollTrackOptions;
  _props$scrollTrackOpt = _props$scrollTrackOpt === void 0 ? {} : _props$scrollTrackOpt;
  var type = _props$scrollTrackOpt.type,
    scrollCallback = _props$scrollTrackOpt.scrollCallback,
    trackScrollToEnd = _props$scrollTrackOpt.trackScrollToEnd,
    _props$scrollTrackOpt2 = _props$scrollTrackOpt.scrollThreshold,
    scrollThreshold = _props$scrollTrackOpt2 === void 0 ? 0 : _props$scrollTrackOpt2,
    scrollToEndCallBack = _props$scrollTrackOpt.scrollToEndCallBack;
  var isReachEnd = useRef(false);
  var _onScroll = function onScroll(event) {
    if (trackScrollToEnd && !isReachEnd.current) {
      var _event$nativeEvent = event.nativeEvent,
        layoutMeasurement = _event$nativeEvent.layoutMeasurement,
        contentSize = _event$nativeEvent.contentSize,
        contentOffset = _event$nativeEvent.contentOffset;
      var scrollToEnd = function scrollToEnd() {
        scrollToEndCallBack === null || scrollToEndCallBack === void 0 ? void 0 : scrollToEndCallBack();
        isReachEnd.current = true;
      };
      if (type === ScrollType.Vertical) {
        if (layoutMeasurement.height + contentOffset.y >= contentSize.height - scrollThreshold) {
          scrollToEnd();
        }
      } else if (type === ScrollType.Horizontal) {
        if (layoutMeasurement.width + contentOffset.x >= contentSize.width - scrollThreshold) {
          scrollToEnd();
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement(ScrollView, _extends({
    scrollEventThrottle: 16
  }, props, {
    onScroll: function onScroll(event) {
      var _props$onScroll;
      (_props$onScroll = props.onScroll) === null || _props$onScroll === void 0 ? void 0 : _props$onScroll.call(props, event);
      _onScroll(event);
      scope && emitTrackingEvent(scope);
    },
    onLayout: function onLayout(event) {
      var _props$onLayout;
      (_props$onLayout = props.onLayout) === null || _props$onLayout === void 0 ? void 0 : _props$onLayout.call(props, event);
      scope && emitTrackingEvent(scope);
    },
    onScrollEndDrag: function onScrollEndDrag() {
      scrollCallback === null || scrollCallback === void 0 ? void 0 : scrollCallback();
    }
  }), props.children);
};